import React from 'react';
import classNames from 'classnames';
var DotGroup = function (props) {
    var activeIndex = props.activeIndex, position = props.position, amount = props.amount, itemOnClick = props.itemOnClick, prefixCls = props.prefixCls;
    return (React.createElement("ul", { className: prefixCls + "__dots-container " + prefixCls + "_dots-" + position }, Array(amount)
        .fill(0)
        .map(function (_, idx) {
        var _a;
        var dotClassName = classNames(prefixCls + "__dot", (_a = {},
            _a[prefixCls + "__dot_active"] = idx === activeIndex,
            _a));
        return React.createElement("li", { key: idx, className: dotClassName, onClick: function () { return itemOnClick(idx); } });
    })));
};
export default DotGroup;
//# sourceMappingURL=dot-group.js.map